import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0932 = React.lazy(() => import('./symbols/0932_sofa_armchair'));
const Symbol0933 = React.lazy(() => import('./symbols/0933_table_reading_light'));
const Symbol0934 = React.lazy(() => import('./symbols/0934_archive_shelves_sideboard'));
const Symbol0935 = React.lazy(() => import('./symbols/0935_wardrobe_shelves'));
const Symbol0936 = React.lazy(() => import('./symbols/0936_book_wall_shelf'));
const Symbol0937 = React.lazy(() => import('./symbols/0937_plant_green_decoration'));
const Symbol0938 = React.lazy(
  () => import('./symbols/0938_tree_decoration_christmas_new_year_lights')
);
const Symbol0939 = React.lazy(() => import('./symbols/0939_candle_christmas_light'));
const Symbol0940 = React.lazy(() => import('./symbols/0940_hammer_home_utilities'));
const Symbol0941 = React.lazy(() => import('./symbols/0941_safety_pin'));
const Symbol0942 = React.lazy(() => import('./symbols/0942_hotel_room_tag'));
const Symbol0943 = React.lazy(() => import('./symbols/0943_mustache_movember_men'));
const Symbol0944 = React.lazy(() => import('./symbols/0944_t-shirt'));
const Symbol0945 = React.lazy(() => import('./symbols/0945_foot_shoe_steps'));
const Symbol0946 = React.lazy(() => import('./symbols/0946_animal_foot_steps'));
const Symbol0947 = React.lazy(() => import('./symbols/0947_power_on_off'));
const Symbol0948 = React.lazy(() => import('./symbols/0948_socket_power_electricity_plug'));
const Symbol0949 = React.lazy(() => import('./symbols/0949_plug_power_electricity'));
const Symbol0950 = React.lazy(() => import('./symbols/0950_light_bulb_idea'));
const Symbol0951 = React.lazy(() => import('./symbols/0951_flashlight'));
const Symbol0952 = React.lazy(() => import('./symbols/0952_thermometer_temperature_hot'));
const Symbol0953 = React.lazy(() => import('./symbols/0953_thermometer_temperature_cold'));
const Symbol0954 = React.lazy(() => import('./symbols/0954_air_conditioner_temperature'));
const Symbol0955 = React.lazy(() => import('./symbols/0955_air_ventilator_flow'));
const Symbol0956 = React.lazy(() => import('./symbols/0956_bath_shower'));
const Symbol0957 = React.lazy(() => import('./symbols/0957_bathtub_shower'));
const Symbol0958 = React.lazy(() => import('./symbols/0958_bathtub'));
const Symbol0959 = React.lazy(() => import('./symbols/0959_city_flat_homes'));
const Symbol0960 = React.lazy(() => import('./symbols/0960_city_house_home'));
const Symbol0961 = React.lazy(() => import('./symbols/0961_city_skyscraper_flat'));
const Symbol0962 = React.lazy(() => import('./symbols/0962_home_plant_door'));
const Symbol0963 = React.lazy(() => import('./symbols/0963_plant_green'));
const Symbol0964 = React.lazy(() => import('./symbols/0964_bonsai_tree_plant_green'));
const Symbol0965 = React.lazy(() => import('./symbols/0965_sofa_living_room'));
const Symbol0966 = React.lazy(() => import('./symbols/0966_arm_chair_office'));
const Symbol0967 = React.lazy(() => import('./symbols/0967_table_desk'));
const Symbol0968 = React.lazy(() => import('./symbols/0968_bookshelf_sideboard'));
const Symbol0969 = React.lazy(() => import('./symbols/0969_chest_drawers_sideboard'));
const Symbol0970 = React.lazy(() => import('./symbols/0970_bed'));
const Symbol0971 = React.lazy(() => import('./symbols/0971_tv_shelf'));
const Symbol0972 = React.lazy(() => import('./symbols/0972_light_stand_arc'));
const Symbol0973 = React.lazy(() => import('./symbols/0973_morning_alarm_clock'));
const Symbol0974 = React.lazy(() => import('./symbols/0974_vacuum_cleaner'));
const Symbol0975 = React.lazy(() => import('./symbols/0975_cleaning_spray_gun'));
const Symbol0976 = React.lazy(() => import('./symbols/0976_paper_towel'));
const Symbol0977 = React.lazy(() => import('./symbols/0977_fish_bowl_goldfish'));

export interface IProps {}

const Home: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0932_sofa_armchair" symbol={<Symbol0932 />} />
      <LazySymbol id="0933_table_reading_light" symbol={<Symbol0933 />} />
      <LazySymbol id="0934_archive_shelves_sideboard" symbol={<Symbol0934 />} />
      <LazySymbol id="0935_wardrobe_shelves" symbol={<Symbol0935 />} />
      <LazySymbol id="0936_book_wall_shelf" symbol={<Symbol0936 />} />
      <LazySymbol id="0937_plant_green_decoration" symbol={<Symbol0937 />} />
      <LazySymbol id="0938_tree_decoration_christmas_new_year_lights" symbol={<Symbol0938 />} />
      <LazySymbol id="0939_candle_christmas_light" symbol={<Symbol0939 />} />
      <LazySymbol id="0940_hammer_home_utilities" symbol={<Symbol0940 />} />
      <LazySymbol id="0941_safety_pin" symbol={<Symbol0941 />} />
      <LazySymbol id="0942_hotel_room_tag" symbol={<Symbol0942 />} />
      <LazySymbol id="0943_mustache_movember_men" symbol={<Symbol0943 />} />
      <LazySymbol id="0944_t-shirt" symbol={<Symbol0944 />} />
      <LazySymbol id="0945_foot_shoe_steps" symbol={<Symbol0945 />} />
      <LazySymbol id="0946_animal_foot_steps" symbol={<Symbol0946 />} />
      <LazySymbol id="0947_power_on_off" symbol={<Symbol0947 />} />
      <LazySymbol id="0948_socket_power_electricity_plug" symbol={<Symbol0948 />} />
      <LazySymbol id="0949_plug_power_electricity" symbol={<Symbol0949 />} />
      <LazySymbol id="0950_light_bulb_idea" symbol={<Symbol0950 />} />
      <LazySymbol id="0951_flashlight" symbol={<Symbol0951 />} />
      <LazySymbol id="0952_thermometer_temperature_hot" symbol={<Symbol0952 />} />
      <LazySymbol id="0953_thermometer_temperature_cold" symbol={<Symbol0953 />} />
      <LazySymbol id="0954_air_conditioner_temperature" symbol={<Symbol0954 />} />
      <LazySymbol id="0955_air_ventilator_flow" symbol={<Symbol0955 />} />
      <LazySymbol id="0956_bath_shower" symbol={<Symbol0956 />} />
      <LazySymbol id="0957_bathtub_shower" symbol={<Symbol0957 />} />
      <LazySymbol id="0958_bathtub" symbol={<Symbol0958 />} />
      <LazySymbol id="0959_city_flat_homes" symbol={<Symbol0959 />} />
      <LazySymbol id="0960_city_house_home" symbol={<Symbol0960 />} />
      <LazySymbol id="0961_city_skyscraper_flat" symbol={<Symbol0961 />} />
      <LazySymbol id="0962_home_plant_door" symbol={<Symbol0962 />} />
      <LazySymbol id="0963_plant_green" symbol={<Symbol0963 />} />
      <LazySymbol id="0964_bonsai_tree_plant_green" symbol={<Symbol0964 />} />
      <LazySymbol id="0965_sofa_living_room" symbol={<Symbol0965 />} />
      <LazySymbol id="0966_arm_chair_office" symbol={<Symbol0966 />} />
      <LazySymbol id="0967_table_desk" symbol={<Symbol0967 />} />
      <LazySymbol id="0968_bookshelf_sideboard" symbol={<Symbol0968 />} />
      <LazySymbol id="0969_chest_drawers_sideboard" symbol={<Symbol0969 />} />
      <LazySymbol id="0970_bed" symbol={<Symbol0970 />} />
      <LazySymbol id="0971_tv_shelf" symbol={<Symbol0971 />} />
      <LazySymbol id="0972_light_stand_arc" symbol={<Symbol0972 />} />
      <LazySymbol id="0973_morning_alarm_clock" symbol={<Symbol0973 />} />
      <LazySymbol id="0974_vacuum_cleaner" symbol={<Symbol0974 />} />
      <LazySymbol id="0975_cleaning_spray_gun" symbol={<Symbol0975 />} />
      <LazySymbol id="0976_paper_towel" symbol={<Symbol0976 />} />
      <LazySymbol id="0977_fish_bowl_goldfish" symbol={<Symbol0977 />} />
    </>
  );
});

Home.displayName = 'Home';

export default Home;
